{
    "ChangeMenuTitle": "Änderungsbericht",
    "UnknownReport": "[Unbekannter Bericht]",
    "NoSuitableReportsAvailable": "Keine geeigneten Berichte verfügbar.",
    "DashboardChangeFolderEmpty": "Alle Berichte in diesem Ordner wurden bereits in diesem Dashboard verwendet...",
    "DashboardList_SectionHeader": "Aufführen",
    "DashboardList_Add": "Hinzufügen",
    "DashboardList_AddMenuTitle": "Hinzufügen & Entfernen",
    "DashboardList_MoveUp": "Bewegen Sie sich nach oben",
    "DashboardList_MoveDown": "Sich abwärts bewegen",
    "DashboardList_Remove": "Entfernen",
    "DashboardList_RemoveAll": "Alles entfernen",
    "DashboardList_RemoveAllConfirmMessage": "Möchten Sie wirklich alle Berichte entfernen?",
    "NAME": "DashboardList"
}